import { render, staticRenderFns } from "./SectionLockBadge.vue?vue&type=template&id=2eecc724&scoped=true"
import script from "./SectionLockBadge.vue?vue&type=script&lang=js"
export * from "./SectionLockBadge.vue?vue&type=script&lang=js"
import style0 from "./SectionLockBadge.vue?vue&type=style&index=0&id=2eecc724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eecc724",
  null
  
)

export default component.exports